import { providesList } from '@helpers/providerList';
import BaseService from '../base';
import { VehiclesApiProps, VehicleParams } from './types';

class Vehicle extends BaseService {
  update() {
    return {
      query: ({ id, ...params }: VehicleParams) => ({
        url: `/vehicles/${id}`,
        method: 'PATCH',
        body: params,
      }),
      invalidatesTags: [{ type: this.tagType, id: 'LIST' }, { type: 'Job' }],
    };
  }

  getVehicles() {
    return {
      query: ({ sectionId, ...params }: VehicleParams) => ({
        url: `/section/${sectionId}/vehicles`,
        params,
      }),
      providesTags: (result?: VehiclesApiProps) => providesList(
        result?.section_vehicles,
        this.tagType,
      ),
    };
  }

  getSiteVehicles() {
    return {
      query: ({ siteId, ...params }: VehicleParams) => ({
        url: `/sites/${siteId}/site_vehicles`,
        params,
      }),
      providesTags: (result?: VehiclesApiProps) => providesList(
        result?.section_vehicles,
        this.tagType,
      ),
    };
  }

  addVehicle() {
    return {
      query: ({ id, ...params }: VehicleParams) => ({
        url: `/section/${id}/vehicles`,
        method: 'POST',
        body: params,
      }),
      invalidatesTags: [{ type: this.tagType, id: 'LIST' }, { type: this.tagType }],
    };
  }

  getContractorVehicle() {
    return {
      query: (id: number) => ({
        url: `/contractor-vehicles/${id}`,
      }),
      providesTags: () => [{ type: this.tagType }],
    };
  }
}

export default new Vehicle('vehicles', 'Vehicle');
